"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapperLinks = void 0;
const wrapperLinks = () => {
    document.addEventListener('mouseover', (event) => {
        const target = event.target;
        if (!target.matches('[data-hover="link-wrapper"]'))
            return;
        target.closest('.link-wrapper').classList.add('link-hover');
    });
    document.addEventListener('mouseout', (event) => {
        const target = event.target;
        if (!target.matches('[data-hover="link-wrapper"]'))
            return;
        target.closest('.link-wrapper').classList.remove('link-hover');
    });
};
exports.wrapperLinks = wrapperLinks;
